import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPowerPlant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPowerPlant"><Path d="M9.00077 5C9.00077 4.44772 9.44849 4 10.0008 4H20.0008V2H10.0008C8.34392 2 7.00077 3.34315 7.00077 5V6H9.00077V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M10.8479 7H5.15365L2.82031 21L21.0008 20.9999V9.88185L16.0008 12.3818V9.87769L11.6889 12.046L10.8479 7ZM9.81811 12.9868L9.15365 9H6.8479L5.18123 19H10.8197L9.81479 12.9885L9.81811 12.9868Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPowerPlant;
